import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { switchMap } from 'rxjs';
import { Share } from '@capacitor/share';
import { inviteTeamText } from '../../application/utils';
import {
  AppRoutes,
  COPY_TOKEN,
  CopyProvider,
  DEEP_LINK_TOKEN,
  DeepLinkProvider,
  MODAL_TOKEN,
  ModalProvider,
  TeamsRoutes
} from '@core';
import { TeamInviteData } from '../../application/models';
import { OrIconComponent } from '@ui-components';

@Component({
  selector: 'lib-share-team-modal',
  templateUrl: './share-team-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OrIconComponent],
  standalone: true
})
export class ShareTeamModalComponent {
  private readonly copyProvider: CopyProvider = inject(COPY_TOKEN);
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly deepLinkProvider: DeepLinkProvider = inject(DEEP_LINK_TOKEN);

  // Modal component - must use @Input()
  @Input() teamData!: TeamInviteData;

  advancedShare(): void {
    const teamUrl: string = this.generateTeamUrl();

    Share.share({
      text: inviteTeamText(teamUrl),
      url: teamUrl
    });

    this.modalProvider.dismissModal$().subscribe();
  }

  copyTeamLink(): void {
    const teamUrl: string = this.generateTeamUrl();

    this.copyProvider
      .copyToClipboard(inviteTeamText(teamUrl))
      .pipe(switchMap(() => this.modalProvider.dismissModal$()))
      .subscribe();
  }

  private generateTeamUrl(): string {
    const path: string = `${AppRoutes.TEAMS}/${TeamsRoutes.ACCEPT_INVITATION}/${this.teamData.teamId}/${this.teamData.token}`;

    return this.deepLinkProvider.generateWebLink(path);
  }
}
